const checkIfSignedIn = state => typeof state.session.user !== 'undefined';

const convertCurrency = (price) => {
	const x = price.toString();
	let lastThree = x.substring(x.length - 3);
	const otherNumbers = x.substring(0, x.length - 3);
	if (otherNumbers !== '') { lastThree = `,${lastThree}`; }
	const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
	return (res);
};

const generateUsername = (user) => {
	let username = '';
	const { firstName, lastName, email } = user;
	if (firstName) {
		username += `${firstName}`;
		// TODO : Check if only firstname is available, if it is, then return username
	}
	if (lastName) {
		username += lastName;
		// TODO : Check if only firstname+lastname is available, if it is, then return username
	}
	if (username === '') {
		username = email.split('@')[0];
		// TODO : Check if only this username is available, if it is, then return username else add a number to the end of the name till you get a unique username
	}
	return username.toLowerCase().replace(/ /g, '');
};

const user = {
	checkIfSignedIn: () => state => checkIfSignedIn(state),
	convertCurrency,
	generateUsername,
};

export default user;
